export * from './IconWellGradients';
